import { WeekDay } from './weekday';

export class Week {
    weeknumber: string;
    weekDays: WeekDay[] = [];
    settling = false;
    sendToAfas = false;
}
